import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseCacheService } from 'src/app/core/base/base-cache.service';
import { ApiResponse } from 'src/app/shared/models/api.response';
import { ConfigService } from 'src/app/shared/services/utils/config.service';
import { eDocumentFeature } from '../enum/document-feature.enum';

@Injectable({ providedIn: 'root' })
export class DocumentApiService extends BaseCacheService<any> {
  public constructor(http: HttpClient, configService: ConfigService) {
    super(eDocumentFeature.apiPath, http, configService);
  }

  public createFolders(data: any): Observable<ApiResponse<any>> {
    return this.post<ApiResponse<any>>(eDocumentFeature.apiPath, data);
  }

  public updateFolders(data: any): Observable<ApiResponse<any>> {
    return this.patch<ApiResponse<any>>(eDocumentFeature.apiPath, data);
  }

  public getPdfDocumentFolders(data: any): Observable<ApiResponse<any>> {
    return this.get<ApiResponse<any>>(eDocumentFeature.apiPath, data);
  }

  public getAttestationFiles(data: any): Observable<ApiResponse<any>> {
    const path = data['folderId'] ? `${eDocumentFeature.pdfFilePath}/${data['folderId']}` : eDocumentFeature.pdfFilePath;
    return this.get<ApiResponse<any>>(path, data);
  }

  public createAttestationFile(data: FormData | any): Observable<ApiResponse<any>> {
    return this.post<ApiResponse<any>>(eDocumentFeature.pdfFilePath, data);
  }

  public auditTaskAddFile(data: any): Observable<ApiResponse<any>> {
    return this.put<ApiResponse<any>>(eDocumentFeature.auditTaskAddFilePath, data);
  }

  public deleteDocumentFolder(data: any): Observable<ApiResponse<any>> {
    return this.delete<ApiResponse<any>>(`${eDocumentFeature.apiPath}?folderId=${data['folderId']}`, undefined, data);
  }

  public deleteFile(data: any): Observable<ApiResponse<any>> {
    return this.delete<ApiResponse<any>>(
      `${eDocumentFeature.pdfFilePath}?folderId=${data['folderId']}&companyId=${data['companyId']}&pdfFileId=${data['pdfFileId']}`,
      undefined,
      data
    );
  }

  public deleteFolder(data: any): Observable<ApiResponse<any>> {
    return this.delete<ApiResponse<any>>(`${eDocumentFeature.apiPath}?folderId=${data['folderId']}`, undefined, data);
  }
}
